export const acceptedOrdersColumns = [
  {
    key: "AcceptedDate",
    name: "Numer zamówienia",
    fieldName: "number",
    minWidth: 80,
    maxWidth: 150,
    isResizable: true,
  },
  {
    key: "CreatedAt",
    name: "Data zamówienia",
    fieldName: "createdAt",
    minWidth: 80,
    maxWidth: 120,
    isResizable: true,
  },
  {
    key: "ReceivingDate",
    name: "Data przyjęcia",
    fieldName: "acceptedDate",
    minWidth: 80,
    maxWidth: 120,
    isResizable: true,
  },
  {
    key: "Company",
    name: "Klient",
    fieldName: "company",
    minWidth: 150,
    maxWidth: 250,
    isResizable: true,
  },
  {
    key: "ReceptionPlace",
    name: "Punkt Odbioru",
    fieldName: "receptionPlace",
    minWidth: 100,
    maxWidth: 350,
    isResizable: true,
  },
  {
    key: "Quantity",
    name: "Ilość",
    fieldName: "quantity",
    minWidth: 50,
    maxWidth: 70,
    isResizable: true,
  },
  {
    key: "Type",
    name: "Typ",
    fieldName: "type",
    minWidth: 50,
    maxWidth: 80,
    isResizable: true,
  },
  {
    key: "OrderTypeItemName",
    name: "Rodzaj",
    fieldName: "orderTypeItem",
    minWidth: 40,
    maxWidth: 70,
    isResizable: true,
  },
  {
    key: "ContactPhone",
    name: "Telefon",
    fieldName: "contactPhone",
    minWidth: 50,
    maxWidth: 90,
    isResizable: true,
  },
  {
    key: "IsFromCuo",
    name: "Źródło",
    fieldName: "isFromCuo",
    minWidth: 80,
    maxWidth: 100,
    isResizable: true,
  },
  {
    key: "CuoOrderNumber",
    name: "Numer CUO",
    fieldName: "cuoOrderNumber",
    minWidth: 80,
    maxWidth: 120,
    isResizable: true,
  },

];